import { action, observable } from 'mobx';
import { FILTER_DATA_MAP } from '../../Constant/filterBarData';
import { SearchResultStoreModel } from './index';
import { qav } from '../../Utils/qav';
class UiState {
    // 是否开启筛选栏功能
    @observable
    public enableFilter = false;

    // 是否展示筛选栏
    @observable
    public isShowFilterBar = false;

    // 筛选栏标题
    @observable
    public filterBarTitle = '';

    // 订单页面来源
    public sourceFrom = '';
    // 订单搜索
    public searchType = 1;
    public searchKey = '';
    public searchTagKey = '';
    public searchBusinessValue = '';
    public searchOrderStatus = '';

    // 当前选中的状态栏
    @observable
    public statusFilter = 'all';

    @observable
    public businessValue = FILTER_DATA_MAP.all.value;

    @observable
    public businessId = 'all';

    @observable
    public isLogin = false;

    // 展示上方登录按钮条
    @observable
    public showLoginBar = false;

    public rootStore: SearchResultStoreModel;

    public constructor(rootStore: SearchResultStoreModel) {
        this.rootStore = rootStore;
    }
    @action
    public toggleShowLoginBar = (showLoginBar: boolean) => {
        this.showLoginBar = showLoginBar;
        if (showLoginBar) {
            qav({
                page: this.rootStore.pageName,
                module: 'loginBtn',
                path: [{ title: '登录', position: '0' }],
                operType: 'show'
            });
        }
    };

    public setSourceFrom = (sourceFrom: string) => {
        this.sourceFrom = sourceFrom;
    };

    @action
    public setBusinessValue = (businessValue: string) => {
        this.businessValue = businessValue;
    };

    @action
    public setBusinessId = (businessId: string) => {
        this.businessId = businessId;
    };

    @action
    public setIsLogin = (isLogin: boolean) => {
        this.isLogin = isLogin;
    };
}

export default UiState;
